export default "__VITE_ASSET__FnV947C$__"